import Subscription from '@/Component/Brand/Subscription'

const subscriptionPage = () => {
  return (
    <div>
      <Subscription/>
    </div>
  )
}

export default subscriptionPage
